/// <reference path="../../typings/globals/core-js/index.d.ts" />

import { bootstrap }    from '@angular/platform-browser-dynamic';
import { AppComponent } from './app.component';
bootstrap(AppComponent);
